export default "__VITE_ASSET__BzTdhiPo__"